"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.to-string");require("core-js/modules/es6.number.constructor");require("core-js/modules/es6.regexp.split");require("core-js/modules/es6.function.name");require("core-js/modules/web.dom.iterable");


















































































































































































var _aliOss = _interopRequireDefault(require("@/utils/aliOss"));
var _taskSkillLayout = _interopRequireDefault(require("./taskSkillLayout"));
var _taskSkillTabs = _interopRequireDefault(require("./taskSkillTabs"));
var _taskSkillPoint = _interopRequireDefault(require("./taskSkillPoint"));
var _taskEventList = _interopRequireDefault(require("./taskEventList")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { name: 'TaskTable', components: { TaskSkillLayout: _taskSkillLayout.default, TaskSkillPoint: _taskSkillPoint.default, TaskSkillGroup: _taskSkillTabs.default, TaskEvent: _taskEventList.default }, data: function data() {return { cycleTimeData: [], postActionList: [], triggerList: [], triggerCodeList: [], intentionList: [], taskRobots: [], robots: [], wDays: [], mapArr: [], robotId: '', newadd: false, eventAdd: false, mapShow: false, isShowTabs: true, title: '', flowId: '', mapId: '', addData: { id: '', endTime: '', startTime: '', workTime: [], frequency: '0', frequencyNum: '', isCircle: '0', isEnable: '1', mapId: '', name: '', postAction: '0', intention: '', intentions: '', postBroadcast: '', triggerType: '', triggerCode: '', triggerId: '', eventName: '', workDays: [], robotIds: [] }, rules: { mapId: [{ required: true, message: '请选择地图', trigger: 'blur' }], name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }], triggerType: [{ required: true, message: '请选择命令类型', trigger: 'blur' }], postBroadcast: [{ required: false, message: '请输入结束播报内容', trigger: 'blur' }], workDays: [{ required: true, validator: this.workDayValidate, trigger: 'blur' }], intention: [{ required: true, validator: this.handleIntentionValidate, trigger: 'blur' }], triggerId: [{ required: true, validator: this.handleTriggerCodeValidate, trigger: 'blur' }], robotIds: [{ required: true, message: '请选择机器人', trigger: 'blur' }], // workTime: [{
        //   required: true,
        //   validator: this.handleWorkTimeValidate,
        //   trigger: 'blur'
        // }],
        startTime: [{ required: true, message: '请选择驱动时间', trigger: 'change' }], endTime: [{ required: true, validator: this.handleEndTimeValidate, trigger: 'change' }], frequency: [{ required: true, message: '请输入巡逻频率', trigger: 'blur' }], isCircle: [{ required: true, validator: this.handleCircleValidate, trigger: 'blur' }], postAction: [{ required: true, message: '请输入完成动作', trigger: 'blur' }] } };}, mounted: function mounted() {var self = this; // var task = self.$route.query.data
    var taskId = self.$route.params.parentId;self.getTask(taskId);self.getCycleData(self);self.handleGetPostList();self.handleGetTriggerList();self.handleGetTriggerCode();self.handleGetMaps();self.handleGetIntention();self.isShowTabs = false;}, methods: { getTask: function getTask(taskId) {var self = this;self.getData('/api/temi/robot/task?id=' + taskId, {}, function (res) {self.updateMenu(res);});}, getTaskRobots: function getTaskRobots(taskId) {var self = this;self.robots = [];var path = 'api/temi/robot/task/' + taskId + '/refRobot';self.getData(path, self.searchData, function (res) {// 组装机器人数据
        if (res.notInTaskRobot) {res.notInTaskRobot = res.notInTaskRobot.concat(res.inTaskRobot);res.notInTaskRobot.forEach(function (robot) {var r = { key: robot.id, label: robot.name };self.robots.push(r);});} // 组装任务管理的机器人
        if (res.inTaskRobot) {self.addData.robotIds = [];res.inTaskRobot.forEach(function (robot) {self.addData.robotIds.push(robot.id);});}});}, handleGetMaps: function handleGetMaps() {var self = this;var path = '/api/temi/robot/map';self.getData(path, {}, function (res) {self.mapArr = res;});}, handleGetIntention: function handleGetIntention() {var self = this;var path = '/api/faDict/list?parentCode=taskDoneInquiryIntention';
      self.getData(path, {}, function (res) {
        self.intentionList = res;
      });
    },
    handleGetTriggerCode: function handleGetTriggerCode() {
      var self = this;
      var path = '/api/faDict/list?parentCode=taskDriverOrder';
      self.getData(path, {}, function (res) {
        self.triggerCodeList = res;
      });
    },
    handleSetSkillParamShow: function handleSetSkillParamShow(flowId) {
      var self = this;
      self.mapShow = false;
      self.isShowTabs = true;
      self.flowId = flowId;
      /* self.newadd = true
                            if (self.$refs['skillLayout']) {
                              self.$refs.skillLayout.handleGetSkillData(self.addData.id, flowId)
                            }*/
      // 修改显示的组件
      if (self.$refs.skillGroup) {
        self.$refs.skillGroup.handleGetSkillGroupData(self.addData.id, flowId);
      }
    },
    handleSkilMapShow: function handleSkilMapShow() {
      var self = this;
      self.mapShow = true;
      self.newadd = false;
    },
    handleFlowShow: function handleFlowShow() {
      var self = this;
      self.mapShow = true;
      var addDataMapId = self.addData.mapId + '';
      self.mapId = addDataMapId;
      if (self.$refs['skillPoint']) {
        self.$refs['skillPoint'].handleGetData(self.addData.id, addDataMapId);
      }
    },
    handleGetPostList: function handleGetPostList() {
      var actionArr = ['回到充电桩', '暂停'];
      for (var index in actionArr) {
        var pAction = {
          'value': index,
          'name': actionArr[index] };

        this.postActionList.push(pAction);
      }
      console.log('post', this.postActionList);
    },
    handleGetTriggerList: function handleGetTriggerList() {
      var actionArr = ['时间驱动', '事件驱动'];
      for (var index in actionArr) {
        var pAction = {
          'value': index,
          'name': actionArr[index] };

        this.triggerList.push(pAction);
      }
    },
    handleShowEvent: function handleShowEvent() {
      this.eventAdd = true;
    },
    getCycleData: function getCycleData(self) {
      var arrWeek = ['周天', '周一', '周二', '周三', '周四', '周五', '周六'];
      for (var i = 0; i < 7; i++) {
        var week = {
          'name': arrWeek[i],
          'value': i + 1 };

        self.cycleTimeData.push(week);
      }
    },
    workDayValidate: function workDayValidate(rule, value, callBack) {
      var self = this;
      if (self.addData.isCircle === '1' && self.addData.workDays.length === 0) {
        callBack(new Error('请选择周期时间'));
      } else {
        callBack();
      }
    },
    // handleWorkTimeValidate: function(rule, value, callBack) {
    //   const self = this
    //   if (self.addData.triggerType === '0' && self.addData.workTime.length === 0) {
    //     callBack(new Error('请选择驱动时间'))
    //   } else {
    //     callBack()
    //   }
    // },
    handlestartTimeValidate: function handlestartTimeValidate(rule, value, callBack) {
      var self = this;
      if (self.addData.triggerType === '0' && self.addData.startTime.length === 0) {
        callBack(new Error('请选择驱动开始时间'));
      } else {
        callBack();
      }
    },
    handleEndTimeValidate: function handleEndTimeValidate(rule, value, callBack) {
      var self = this;
      if (self.addData.triggerType === '0' && self.addData.endTime.length === 0) {
        callBack(new Error('请选择驱动结束时间'));
      } else {
        callBack();
      }
    },

    handleTriggerCodeValidate: function handleTriggerCodeValidate(rule, value, callBack) {
      var self = this;
      if (self.addData.triggerType === '1' && !self.addData.triggerCode) {
        callBack(new Error('请选择驱动命令'));
      } else {
        callBack();
      }
    },
    handleCircleValidate: function handleCircleValidate(rule, value, callBack) {
      var self = this;
      if (self.addData.triggerType === '0' && self.addData.isCircle === '') {
        callBack(new Error('请选择作用周期'));
      } else {
        callBack();
      }
    },
    handleIntentionValidate: function handleIntentionValidate(rule, value, callBack) {
      var self = this;
      if (self.addData.postAction === '2' && !self.addData.intention) {
        callBack(new Error('请选择意图'));
      } else {
        callBack();
      }
    },
    getOrganziationList: function getOrganziationList() {
      var self = this;
      self.getData('/api/institution/dropList/0', {}, function (res) {
        self.organizationList = res;
      });
    },
    resetFun: function resetFun() {// 重置
      this.searchData.sn = '';
      this.searchData.name = '';
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      if (this.searchData.deliverTimeEnd) {
        var endTime = this.searchData.deliverTimeEnd;
        if (endTime.split(' ').length < 2) {
          endTime = endTime + ' 23:59:59';
          this.searchData.deliverTimeEnd = endTime;
        }
      }
      if (this.searchData.deliverTimeStart) {
        var startTime = this.searchData.deliverTimeStart;
        if (startTime.split(' ').length < 2) {
          startTime = startTime + ' 00:00:00';
          this.searchData.deliverTimeStart = startTime;
        }
      }
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    handleCheckChange: function handleCheckChange(val) {
    },
    fnUploadRequest: function fnUploadRequest(option) {
      var path = 'robot/news';
      _aliOss.default.ossUploadFile(option, path);
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.newadd = true;
    },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      var self = this;
      self.mapShow = true;
      self.newadd = false;
      self.isShowTabs = false;
      if (this.$refs['skillLayout']) {
        self.$refs.skillLayout.handleClearParams();
      }
    },
    closeEventDiglog: function closeEventDiglog() {// 关闭弹出层
      var self = this;
      self.eventAdd = false;
    },
    beforeRemove: function beforeRemove(file, fileList) {
      var fileName = file.name;
      var confirm = '确定移除' + fileName + '？';
      return this.$confirm(confirm);
    },
    handleOnRemove: function handleOnRemove(file, fileList) {
      this.addData.icon = '';
      this.$message('移除' + file.name + '成功');
    },
    onsuccess: function onsuccess(res) {
      var iconUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;
      this.addData.icon = iconUrl;
    },
    updateMenu: function updateMenu(item) {// 修改操作
      console.log('item111', item);
      var self = this;
      var frequency = '0';
      if (item.frequency > 0) {
        frequency = '1';
      }
      var itemMapId = item.mapId === null ? '' : item.mapId;
      self.addData = {
        id: item.id,
        name: item.name,
        frequency: frequency,
        frequencyNum: item.frequency,
        postAction: item.postAction + '',
        intentions: item.intentions,
        isCircle: item.isCircle ? '1' : '0',
        mapId: itemMapId,
        startTime: item.startTime,
        endTime: item.endTime,
        isEnable: item.isEnable ? '1' : '0',
        triggerType: item.triggerType ? item.triggerType + '' : '0',
        triggerCode: item.triggerCode,
        triggerId: item.triggerId,
        postBroadcast: item.postBroadcast,
        eventName: item.triggerName ? item.triggerName : '',
        // workTime: ['', ''],
        workDays: [],
        robotIds: [] };


      if (self.addData.postAction === 'null') {
        self.addData.postAction = '0';
      }
      console.log('self.addData', self.addData);
      if (item.workDays) {
        var days = item.workDays.split(',');
        self.wDays = [0, 1, 2];
        days.forEach(function (day) {
          self.addData.workDays.push(Number(day));
        });
      }
      console.log('self.addData.startTime', self.addData.startTime);
      // if (self.addData.startTime && self.addData.endTime) {
      //   self.addData.workTime = [self.addData.startTime, self.addData.endTime]
      // }
      /* if (item.startTime && item.endTime) {
        var time1 = item.startTime.split(':')
        var time2 = item.endTime.split(':')
         if (time1.length > 2 && time2.length > 2) {
          var data1 = new Date()
          data1.setHours(time1[0])
          data1.setMinutes(time1[1])
          data1.setSeconds(time1[2])
          var data2 = new Date()
          data2.setHours(time1[0])
          data2.setMinutes(time1[1])
          data2.setSeconds(time1[2])
          self.addData.workTime = [data1, data2]
        }
      } */

      self.getTaskRobots(item.id);
    },
    onSubmit: function onSubmit() {var _this = this; // 新增提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          // if (self.addData.workTime) {
          //   if (self.addData.workTime[0] !== '') {
          //     self.addData.startTime = self.addData.workTime[0]
          //   }
          //   if (self.addData.workTime[1] !== '') {
          //     self.addData.endTime = self.addData.workTime[1]
          //   }
          // }
          if (self.addData.startTime > self.addData.endTime) {
            _this.$notify.error({
              title: '错误',
              message: '驱动结束时间要大于开始时间' });

            self.addData.endTime = '';
            return false;
          }
          var task = {
            id: self.addData.id,
            endTime: self.addData.endTime,
            startTime: self.addData.startTime,
            frequency: Number(self.addData.frequency),
            isCircle: Number(self.addData.isCircle),
            isEnable: Number(self.addData.isEnable),
            mapId: self.addData.mapId,
            name: self.addData.name,
            postAction: Number(self.addData.postAction),
            workDays: '',
            postBroadcast: self.addData.postBroadcast,
            triggerType: self.addData.triggerType,
            triggerId: self.addData.triggerId,
            triggerCode: self.addData.triggerCode };

          if (self.addData.workDays) {
            task.workDays = self.addData.workDays.toString();
          }
          if (self.addData.frequencyNum && self.addData.frequency !== '0') {
            task.frequency = Number(self.addData.frequencyNum);
          }
          var postData = {
            'task': task,
            'robotIds': self.addData.robotIds };

          self.postData('/api/temi/robot/task/', postData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.$emit('refreshTaskList', self.addData.id);
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/temi/robot?id=' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        title: '',
        longContent: '',
        orderNum: 0,
        icon: '' };

    },
    openOrgDialog: function openOrgDialog(robotId) {
      var self = this;
      self.robotId = robotId;
      self.getIns(robotId);
      self.getOrganziationList();
      self.modOrg = true;
    },
    closeOrgDialog: function closeOrgDialog() {
      this.modOrg = false;
      this.insId = '';
      this.robotId = '';
      this.$refs.orgTree.setCheckedKeys([]);
    },
    checkFn: function checkFn(node, data) {
      var currKey = node.id;
      this.$refs.orgTree.setCheckedKeys([currKey]);
      this.insId = currKey;
    },
    returnFun: function returnFun(item) {
      // 返回上一级
      var self = this;
      self.$router.push('/robot/quest/task');
    },
    getIns: function getIns(robot) {
      var self = this;
      self.getData('api/temi/robot/ins/' + robot, {}, function (res) {
        if (res.robotInsInfo !== null) {
          self.insId = res.robotInsInfo.insId;
          if (self.insId !== '') {
            self.$refs.orgTree.setCheckedKeys([self.insId]);
          }
        }
      });
    },
    getCheckEvent: function getCheckEvent(event) {
      var self = this;
      self.addData.triggerId = event.id;
      self.addData.eventName = event.name;
      self.addData.triggerCode = event.code;
    },
    handleGetEvent: function handleGetEvent() {
      var self = this;
      var event = this.$refs.taskEvent.addData;
      self.addData.triggerId = event.id;
      self.addData.eventName = event.name;
      self.addData.triggerCode = event.code;
      self.eventAdd = false;
    },
    bandIns: function bandIns() {// 新增提交操作
      var self = this;
      var ins = {
        insId: self.insId,
        robotId: self.robotId };

      if (ins.insId === '' || ins.robotId === '') {
        self.$message({ message: '请选择组织', type: 'error' });
        return false;
      }
      self.postData('/api/temi/robot/ins/' + ins.robotId, ins, function (res) {
        self.$message({
          message: '添加成功!',
          type: 'success' });

        self.closeOrgDialog();
        self.searchData.page = 1;
        self.init();
      });
    } } };exports.default = _default;